import React from 'react';

import {Box} from 'src/design/atoms/Box';
import Parser from 'html-react-parser';
import type {
  CourseSessionContentResponse,
  CourseSessionCurrentContentResponse,
  CourseSessionQuizQuestionResponse,
} from 'src/api/ProactApiClient';
import {Subtitle} from 'src/design/atoms/Typography';
import {FormViewRow} from 'src/app/forms/FormViewRow/FormViewRow';
import {useAppSelector} from 'src/redux/hooks';
import {fixRichTextTokens} from 'src/shared/utils/imageHandler';
import SessionQuizForm from './SessionQuizForm';
import {GetQuizScoreLine, GetSessionSubtitle} from './sessionHelpers';

export interface TrackerActiveSessionQuizProps {
  contentResponse: CourseSessionCurrentContentResponse;

  onSessionContentChange: (
    sessionContent: CourseSessionContentResponse
  ) => void;

  onSubmit: () => void;
}
export const TrackerActiveSessionQuiz: React.FC<
  TrackerActiveSessionQuizProps
> = ({contentResponse, onSessionContentChange, onSubmit}) => {
  const {accessToken} = useAppSelector(state => state.auth);

  const {
    contentDefinition: content,
    contentSession,
    currentContextIndex,
    totalContentLength,
  } = contentResponse;
  const title = GetSessionSubtitle(
    currentContextIndex,
    totalContentLength,
    content?.quiz?.headerText
  );

  const {
    bodyText: description,
    scorePassPercentage,
    questions,
  } = content!.quiz!;

  function handleQuestionsChange(
    questions: CourseSessionQuizQuestionResponse[]
  ): void {
    onSessionContentChange({
      ...contentSession!,
      quiz: {
        ...contentSession!.quiz,
        questions: questions,
      },
    });
  }

  return (
    <Box>
      <Subtitle text={title} />
      {description && (
        <FormViewRow
          label="Description"
          value={Parser(fixRichTextTokens(description as string, accessToken))}
        />
      )}
      <p>{GetQuizScoreLine(scorePassPercentage, questions)}</p>
      <SessionQuizForm
        questions={questions ?? []}
        sessionQuestions={contentSession?.quiz?.questions ?? []}
        onSessionQuestionsChange={handleQuestionsChange}
        onQuizSubmit={onSubmit}
      />
    </Box>
  );
};
